module.exports = __webpack_public_path__ + "img/teaser_traktor4.acc812e7.jpg";